import { Search } from '@mui/icons-material';
import { Input } from '@on3/ui-lib/components/Input/Input';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import styles from './PlayerSearch.module.scss';

export const PlayerSearch = () => {
  const router = useRouter();
  const coachProfile = router.pathname.includes('coach');
  const [playerQuery, setPlayerQuery] = useState('');

  const handleChange = (value: string) => {
    setPlayerQuery(value);
  };

  const handleSearchSubmit: React.FormEventHandler<
    HTMLFormElement | HTMLButtonElement
  > = useCallback(
    (e) => {
      // don't want the whole page refreshing */
      e.preventDefault();
      router.push(`/db/search?searchText=${playerQuery}`);
    },
    [playerQuery, router],
  );

  return (
    <form className={styles.block} onSubmit={handleSearchSubmit}>
      <Input
        id="player-search-input"
        label="Player Search"
        name="searchText"
        onChange={(e) => handleChange(e.target.value)}
        placeholder={coachProfile ? 'Search Coaches' : 'Search Players'}
        srLabel
        suffix={
          <button onClick={handleSearchSubmit} type="submit">
            <Search />
          </button>
        }
        type="text"
        value={playerQuery}
      />
    </form>
  );
};
